import { Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { AppState } from '../../app.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../common/global-variables';
import { Observable, Subject, Subscription } from 'rxjs';
import { HttpUtils } from '../../../common/http/http-utils';
import { Dropdown } from '@clr/angular';

import { JobsNotifierService } from '../../services/job-notifier.service';

import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';

@Component({
    selector: 'mini-activity-log',
    styles: [
        require('./activity-log.scss')
    ],
    template: require('./mini-activity-log.html'),
    encapsulation: ViewEncapsulation.None
})

export default class MiniActivityLog {
    @ViewChild(Dropdown) activityDropDown: Dropdown;

    private url: string = '/hybridity/api/jobsForActivityLog?pageSize=5';
    private subscription;
    private runningJobsCountSubscription;
    private refreshActivityLogSubscription;
    private loading: boolean = true;
    private value: string = '';
    private jobs = [];
    private runningJobsCount = 0;

    constructor(public appState: AppState, public translate: TranslateService, public http: HttpClient,
                 public jobNotifierService: JobsNotifierService, private router: Router) {
        translate.use(GlobalVariables.LOCALE);
        this.runningJobsCountSubscription = this.jobNotifierService.getRunningJobsCount().subscribe(count => {
                this.runningJobsCount = ( count ) ? count : 0;
            },
            error => {},
            () => {}
        );
        this.refreshActivityLogSubscription = this.jobNotifierService.getRefreshActivityLogEvent().subscribe(() => {
                this.refresh();
            },
            error => {},
            () => {}
        );
        this.refresh();
    }

    pollJobs() {
        return this.http.get(HttpUtils.getBaseUrl() + this.url).map(
            res => res
        );
    }

    refresh() {
        this.loading = true;
        this.subscription = this.pollJobs().subscribe(res => {
                this.getJobs(res);
            },
            error => this.onPollFailure(),
            () => {
                if (this.subscription) {
                    this.subscription.unsubscribe();
                }
            }
        );
    }

    onPollFailure() {
        this.loading = false;
    }

    getJobs(res) {
        this.loading = true;
        this.jobs.length = 0;
        let jobsArray: Array<Object> = [];
        if (res && res.data && res.data.activityLogs) {
            jobsArray = res.data.activityLogs;
        }
        for (let job of jobsArray) {
            if (job) {
                if (job['isDone'] ) {
                    if (job['didFail']) {
                        job['status'] = 'failure';
                    } else {
                        job['status'] = 'success';
                    }
                } else {
                    job['status'] = 'running';
                }
            }
            this.jobs.push(job);
        }
        this.loading = false;
    }

    ngOnDestroy() {
        if (this.runningJobsCountSubscription ) this.runningJobsCountSubscription.unsubscribe();
        if (this.refreshActivityLogSubscription ) this.refreshActivityLogSubscription.unsubscribe();
        if (this.subscription ) this.subscription.unsubscribe();
    }

    viewActivityLog() {
        // this.activityDropDown.open = false;
        this.router.navigate(['/activities']);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/activity-log/mini-activity-log.component.ts